import { defineStore } from 'pinia';
import { ref } from 'vue';

export interface Toast {
  id: number;
  message: string;
  type: 'info' | 'success' | 'error';
}

let counter = 0;

export const useToastStore = defineStore('toast', () => {
  const toasts = ref<Toast[]>([]);

  function show(message: string, type: Toast['type'] = 'info') {
    if (type === 'error' && toasts.value.some((toast) => toast.type === 'error' && toast.message === message)) return;
    const id = ++counter;
    toasts.value.push({ id, message, type });
    if (type !== 'error') setTimeout(() => dismiss(id), 3000);
  }

  function success(message: string) { show(message, 'success'); }
  function error(message: string) { show(message, 'error'); }
  function info(message: string) { show(message, 'info'); }

  function dismiss(id: number) {
    toasts.value = toasts.value.filter((t) => t.id !== id);
  }

  return { toasts, show, success, error, info, dismiss };
});
